import "./styles.less";

import { Carousel, Space, Typography } from "antd";
import React, { useState } from "react";

import { CarouselArrow } from "../../../../Components/Property/LazyImageGallery/CarouselArrow/web";
import { ImagenOptimizada } from "../../../../Components/Image/web";
import { PropComponentMode } from "../../../../Components/Property/PropertyInterfaces";
import { useTheme } from "../../../../Styles/ThemeHook";
import { useWorkProgress } from "../../../../Components/Project/WorkProgress/WorkProgress.hook";

const { Text } = Typography;
export const PropertyModalWorkProgress = ({ data }: { data: Image[] }) => {
	const { images } = useWorkProgress(data);
	const { theme } = useTheme();
	const [current, setCurrent] = useState(0);
	// if (error) return null;
	// if (loading) return <>...</>;

	const settings = {
		dots: false,
		arrows: true,

		nextArrow: <CarouselArrow side={"right"} />,
		prevArrow: <CarouselArrow side={"left"} />,
		infinite: true,
		autoplay: false,
		slidesToScroll: 1,
		slidesToShow: 1,
		speed: 300,
		style: {
			height: "100%",
		},
	};

	return (
		<div className={"property-modal-workprogress"}>
			<Carousel {...settings} afterChange={setCurrent}>
				{images.map((g, i) => {
					return (
						<div className={"gallery-image"} key={"Gallery_" + i}>
							<ImagenOptimizada src={g.image} alt="Image" />
						</div>
					);
				})}
			</Carousel>
			<div className="photos-footer">
				<Space size={theme.spacing.xsSpacing}>
					<Text>{current + 1}</Text>
					<Text>/</Text>
					<Text>{images.length}</Text>
				</Space>
			</div>
		</div>
	);
};
